import React from 'react';
import { Neo, NeoGrid, Views } from '@singularsystems/neo-react';
import ExportColumnConfigurationsVM from './ExportColumnConfigurationsVM';
import { observer } from 'mobx-react';
import { TextConstants } from '../../../Common/TextConstants';
import StaticExportColumnSpecLookup from '../Models/Lookups/StaticExportColumnSpecLookup';
import ManageExportColumnSpecComponent from '../Components/ManageExportColumnSpecComponent';
import Loading from '../../../App/Components/Loading/Loading';
import { ColumnConfiguration, FileConfigurations } from '../../../AccessControl/Models/Commands/Security/Roles';

class ExportColumnConfigurationsParams {
    public exportFileSpecId = {};
    public exportFileSpecProps = {};
}

@observer
export default class ExportColumnConfigurationsView extends Views.ViewBase<ExportColumnConfigurationsVM, ExportColumnConfigurationsParams> {
    public static params = new ExportColumnConfigurationsParams();

    public initialise() {
        this.viewModel.initialise(Number(this.viewParams.exportFileSpecId.value), String(this.viewParams.exportFileSpecProps.value));
        this.viewModel.pageManager.refreshData();
    }

    constructor(props: unknown) {
        super("Export Column Configurations", ExportColumnConfigurationsVM, props);
    }

    public render() {
        return (
            <>
                {(this.viewModel.taskRunner.isBusy) && <Loading />}
                {this.viewModel.showManageColumnComponent &&
                    <ManageExportColumnSpecComponent
                        viewModel={this.viewModel.manageExportColumnSpecComponentVM}
                        onSave={() => this.viewModel.saveExportColumnSpec()}
                        onCancel={() => this.viewModel.cancel()} />}

                {!this.viewModel.showManageColumnComponent &&
                    <Neo.Card title={TextConstants.Titles.ExportColumnConfiguration} className="m-1">
                        <div>
                            <Neo.Form model={this.viewModel.exportColumnConfigurationSearchCriteria} onSubmit={() => this.viewModel.exportColumnConfigurationSearchCriteria.meta.searchCriteria.value === "" ? this.viewModel.pageManager.refreshData() : this.viewModel.clearSearch()}>
                                {this.viewModel.authorisationService.hasRole(ColumnConfiguration.AddNew) &&
                                    <div className="row pb-2">
                                        <div className='col text-right'>
                                            <Neo.Button
                                                onClick={() => this.viewModel.addColumn()}
                                                variant="primary" size="sm"
                                            >{TextConstants.Buttons.AddColumn}</Neo.Button>
                                        </div>
                                    </div>
                                }                                
                                <div>
                                    <Neo.FormGroup bindContext={this.viewModel.exportColumnConfigurationSearchCriteria.meta.fileTypeConcatenated} label={TextConstants.Labels.ExportReport}>
                                        <Neo.AutoCompleteDropDown
                                            itemSource={this.viewModel.staticExportFileSpecApiClient.getExportFileSpecDropdownList}
                                            bind={this.viewModel.exportColumnConfigurationSearchCriteria.meta.staticExportFileSpecId}
                                            bindDisplay={this.viewModel.exportColumnConfigurationSearchCriteria.meta.fileTypeConcatenated}
                                            displayMember={"propertiesConcatenated"}
                                            onItemSelected={() => this.viewModel.pageManager.refreshData()}
                                            items={this.viewModel.staticExportFileSpecApiClient.getExportFileSpecDropdownList("").then((arr) => arr.data.slice(0,10))}
                                        />
                                    </Neo.FormGroup>
                                </div>
                                <div>
                                    <Neo.FormGroup label={TextConstants.Labels.SearchColumns}
                                        bind={this.viewModel.exportColumnConfigurationSearchCriteria.meta.searchCriteria}
                                        suppressLabel={true}
                                        placeholder={TextConstants.PlaceHolder.SearchColumns}
                                        append={
                                            <Neo.Button className="btn-small" isSubmit variant="primary">
                                                <i className={`${this.viewModel.exportColumnConfigurationSearchCriteria.meta.searchCriteria.value === "" ? "fa fa-search" : "fa fa-times-circle"}`} />
                                            </Neo.Button>}
                                    />
                                </div>
                            </Neo.Form>
                        </div>
                        <Neo.Pager pageManager={this.viewModel.pageManager} pageControlProps={{ pageSizeLabel: "Show: " }} >
                            <div className="horizontalScroll">
                                <NeoGrid.Grid<StaticExportColumnSpecLookup> className={"table-striped"}>
                                    {(item, meta) => (
                                        <NeoGrid.Row key={item.staticExportColumnSpecId}>
                                            <NeoGrid.Column display={meta.fieldName} />
                                            <NeoGrid.Column display={meta.reportName} />
                                            <NeoGrid.Column display={meta.description} />
                                            <NeoGrid.Column display={meta.dataType} />
                                            <NeoGrid.Column display={meta.columnNumber} />
                                            {this.viewModel.authorisationService.hasRole(ColumnConfiguration.Edit) &&
                                                <NeoGrid.ButtonColumn label={TextConstants.Labels.Edit} className="text-center">
                                                    <Neo.Button
                                                        onClick={() => this.viewModel.editColumnSpec(item)}
                                                        variant="primary" isOutline className="btn-small">
                                                        <i className="fa fa-edit"></i>
                                                    </Neo.Button>
                                                </NeoGrid.ButtonColumn>
                                            }
                                        </NeoGrid.Row>
                                    )}
                                </NeoGrid.Grid>
                            </div>
                        </Neo.Pager>

                        <div className="row pt-2">
                            {this.viewModel.authorisationService.hasRole(FileConfigurations.Access) &&
                                <div className="col">
                                    <Neo.Button
                                        onClick={() => this.viewModel.onBack()}
                                        variant="primary" size="sm"
                                    >{TextConstants.Buttons.Back}</Neo.Button>
                                </div>
                            }
                        </div>

                    </Neo.Card>
                }
            </>
        );
    }
}